var IpcPthPadGeneratorData = require('./ipcPthPadGeneratorData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var HoleData = require('../../holeData.js');
var EllipseData = require('../../../svg/ellipseData.js');
var IPCRules = require('../ipcRules');
var PadData = require('../../padData.js');

var SnapLockData = function(position, angle, init) {
    IpcPthPadGeneratorData.apply(this, arguments);

    this.holeDiameter = this.value("holeDiameter", true);

    this.boardThickness = this.value("boardThickness", true);

    this.lockWidth = this.value("lockWidth", true);
    this.lockHeightMin = this.value("lockHeightMin", true);
    this.lockHeightMax = this.value("lockHeightMax", true);

    this.lockWidthOverride = this.value("lockWidthOverride", true);

    this.getLockWidth = this.cachedFunction("getLockWidth",
        function () {
            if (!this.lockWidthOverride()) {
                return 0.5 * (this.bodyWidthMax() + this.holeDiameter());
            }

            return this.lockWidth();
        },
        [this.lockWidth, this.bodyWidthMax, this.holeDiameter, this.lockWidthOverride]
    );

    this.nonTransformedSegmentedGeometry.addTrigger(this.holeDiameter);
    this.nonTransformedSegmentedGeometry.addTrigger(this.boardThickness);
    this.nonTransformedSegmentedGeometry.addTrigger(this.lockWidth);
    this.nonTransformedSegmentedGeometry.addTrigger(this.lockHeightMin);
    this.nonTransformedSegmentedGeometry.addTrigger(this.lockHeightMax);
};

lib_core.inherit(SnapLockData, IpcPthPadGeneratorData);
lib_core.JsonParser.registerClass(SnapLockData, "SnapLockData");

module.exports = SnapLockData;

SnapLockData.prototype.setupMinMaxPtrMap = function() {
    IpcPthPadGeneratorData.prototype.setupMinMaxPtrMap.call(this);

    this.minMaxPointerMap["lockHeight"] = [this.lockHeightMin, this.lockHeightMax];
    this.validationMap["lockWidth"] = [this.lockWidth];
    this.validationMap["holeDiameter"] = [this.holeDiameter];
    this.validationMap["boardThickness"] = [this.boardThickness];
};

SnapLockData.prototype.getHoleMotif = function() {
    var drillShape = new EllipseData(new lib_geometry.Coord(0, 0), 0, this.holeDiameter(), this.holeDiameter(), true, 0);
    var hole = new HoleData(new lib_geometry.Coord(0,0), 0, drillShape);
    return hole;
};

SnapLockData.prototype.getHoles = function(absolutePositions) {
    var holes = [];
    var holeMotif = this.getHoleMotif();

    holes.push(holeMotif.clone());

    //apply transform on holes if absolute position flag is true
    if (absolutePositions) {
        this.updateObjectTransformation(holes);
    }

    return holes;
};

SnapLockData.prototype.getSilkscreen = function(pads) {
    var body = this.getBodyForSilkscreen();
    var silkscreen = new EllipseData(new lib_geometry.Coord(0,0), 0, body.width, body.width, false, IPCRules.silkscreenStrokeWidth);
    return [silkscreen];
};

SnapLockData.prototype.getAssemblyOutline = function(pads) {
    var body = this.getBodyForAssembly();
    var outline = new EllipseData(new lib_geometry.Coord(0,0), 0, body.width, body.width, false, IPCRules.assemblyOutlineStrokeWidth);
    return outline;
};
